<mat-chip-listbox aria-label="Community list filter" [multiple]="true">
  <!-- Customer -->
  <mat-chip-option
    [selected]="existingFilter.customer"
    (click)="toggleCustomer()"
    >
    <p>{{ "roles.plural.CUSTOMER_SELF" | translate }}</p></mat-chip-option
    >
    <!-- Family -->
    <mat-chip-option [selected]="existingFilter.family" (click)="toggleFamily()">
      <p>{{ "roles.plural.FAMILY" | translate }}</p></mat-chip-option
      >
      <!-- Team member -->
      <mat-chip-option
        [selected]="existingFilter.teamMember"
        (click)="toggleTeamMember()"
        >
        <p>{{ "roles.plural.CARER" | translate }}</p></mat-chip-option
        >
        <!-- Coordinators -->
        <mat-chip-option
          [selected]="existingFilter.coordinator"
          (click)="toggleCoordinator()"
          >
          <p>{{ "roles.plural.COORDINATOR" | translate }}</p></mat-chip-option
          >
          <!-- Admins -->
          <mat-chip-option [selected]="existingFilter.admins" (click)="toggleAdmins()">
            <p>{{ "roles.plural.ADMIN" | translate }}</p></mat-chip-option
            >
            <!-- Pending -->
            @if (existingFilter.showPending) {
              <mat-chip-option
                *hasRole="DASHBOARD_ROLES"
                [selected]="existingFilter.pending"
                (click)="togglePending()"
                >
                <p>{{ "customerDetail.pending" | translate }}</p></mat-chip-option
                >
              }
            </mat-chip-listbox>
